import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import { fetchAccountInvoices, showYoutubeContent } from "../../../../../redux/actions/admin-index"
import Loader from "../../../helpers/loader"
import MUIDataTable from "mui-datatables";
import { createTheme, ThemeProvider, Select, FormControl, MenuItem } from "@mui/material";
import UnSubscribe from "../../Subscription/unSubscribe";
import NextBilling from "./NextBilling";
import axios from "axios";
import { baseUrlDev } from "../../../../Helpers/baseUrl";
import { getLocalUser } from "../../../../TokenControl/parts/useLocalUser";
import useHandleDisable from "../../../helpers/disableSelect";
import CircularProgress from '@mui/material/CircularProgress';
import { useTranslation } from "react-i18next";
import Agreements from "./agreements";
import { IoMdEye } from "react-icons/io";
import CustomPagination from "../../../helpers/CustomPagination";
import CustomSearchRender from "../../../helpers/CustomSearchRender";
import LayoutLoading from "../../../../../Layout_Loading";
import Header from "../../../../shared/Header"
import { CustomBlueButton } from "../../../../Helpers/CustomButtons";
import { getMuiTheme } from "../../../../shared/tableTheme";

const Invoices = () => {
    const handleDisable = useHandleDisable()
    const dispatch = useDispatch()
    const [openA, setOpenA] = useState(false)
    const [sortingColumnName, setSortingColumnName] = useState("created_at");
    const [sortingDirection, setSortingDirection] = useState('desc');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [open, setOpen] = useState(false)
    const [showPage, setShowPage] = useState(false)
    const [loading, setLoading] = useState(false);
    const [loadingRow, setLoadingRow] = useState(null); // Track loading state for each row


    useEffect(() => {
        dispatch(showYoutubeContent('https://www.youtube.com/embed/ROTS4l8tqiM?autoplay=1&mute=0&rel=0'))
    }, [])

    useEffect(() => {
        dispatch(fetchAccountInvoices(page + 1, rowsPerPage, sortingColumnName?.toLocaleLowerCase(), sortingDirection))
        handleDisable()
    }, [page, rowsPerPage, sortingColumnName, sortingDirection])

    const invoices = useSelector(state => state.getInvoices.invoices)

    const user = useSelector(state => state.getUserInfo.user)
    const location = useSelector(state => state.locationSelected.location)
    const { t } = useTranslation()

    useEffect(() => {
        if (location) {
            let location_details = user && user.user.locations.filter(loc => loc.id == location)
            if (location_details && location_details[0] && !location_details[0].is_owner) {
                setShowPage(true)
            } else {
                setShowPage(false)
            }
        }
    }, [location, user])

    if (invoices === undefined) {
        return (
            <LayoutLoading/>
        )
    }

    const handleDownloadPdf = (url, rowIndex) => {
        setLoadingRow(rowIndex);
        setLoading(true);
        axios.post(`${baseUrlDev}invoice/pdf`, { url }, { responseType: 'arraybuffer', headers: { 'Authorization': `Bearer ${getLocalUser().token}`, 'APP-VERSION': 'react' } })
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'file.pdf');
                document.body.appendChild(link);
                link.click();
                setLoading(false);
            })
            .catch(error => {
                // Handle error
            })
            .finally(() => {
                setLoadingRow(null);
            })
    };

    const columns = [
        {
            name: "invoice_no",
            label: t("Invoice number"),
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    // Get the corresponding URL from the row data
                    const rowIndex = tableMeta.rowIndex;
                    const invoiceData = tableMeta.tableData[rowIndex];
                    const invoiceUrl = invoiceData[7]
                    return (
                        <a
                            href={invoiceUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="custom-text-datatable invoice_number_text"
                        >
                            {value}
                        </a>
                    );
                },
                customHeadLabelRender: (columnMeta) => {
                    return <h4 className="custom-label-datatable">{columnMeta.label}</h4>;
                }
            }
        },
        // {
        //     name: t("Plan Name"),
        //     options: {
        //         filter: true,
        //         sort: true,
        //         customBodyRender: (value, tableMeta, updateValue) => (
        //             <p className="custom-text-datatable">{value}</p>
        //         ),
        //         customHeadLabelRender: (columnMeta) => {
        //             return <h4 className="custom-label-datatable">{columnMeta.name}</h4>
        //         }
        //     }
        // },
        {
            name: "reference_no",
            label: t("reference no"),
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value, tableMeta, updateValue) => (
                    <p className="custom-text-datatable">{value}</p>
                ),
                customHeadLabelRender: (columnMeta) => {
                    return <h4 className="custom-label-datatable">{columnMeta.label}</h4>
                }
            }
        },
        {
            name: "amount_due",
            label: t("Amount due"),
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    // Remove the dollar sign if it exists
                    const formattedValue = value.startsWith('$') ? value.slice(1) : value;
                    return <p className="custom-text-datatable">${formattedValue}</p>;
                },
                customHeadLabelRender: (columnMeta) => {
                    return <h4 className="custom-label-datatable">{columnMeta.label}</h4>
                }
            }
        },
        {
            name: "amount_paid",
            label: t("Amount paid"),
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    // Remove the dollar sign if it exists
                    const formattedValue = value.startsWith('$') ? value.slice(1) : value;
                    // Ensure that $0.00 is displayed as $00.00
                    const finalValue = formattedValue === "0.00" ? "00.00" : formattedValue;
                    return <p className="custom-text-datatable">${finalValue}</p>;
                },
                customHeadLabelRender: (columnMeta) => {
                    return <h4 className="custom-label-datatable">{columnMeta.label}</h4>
                }
            }
        },
        {
            name: "paid_at",
            label: t("Paid"),
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    // Determine the CSS class based on the value
                    const className = value === "No" ? "paid-no" : "paid-yes";

                    return (
                        <p className={`custom-text-datatable ${className}`}>
                            {value}
                        </p>
                    );
                },
                customHeadLabelRender: (columnMeta) => {
                    return <h4 className="custom-label-datatable">{columnMeta.label}</h4>;
                },
                setCellProps: (cellValue) => ({
                    className: "paid_td_wrap"
                })
            }
        },
        {
            name: "created_at",
            label: t("Date"),
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    // Format the date
                    const date = new Date(value);
                    // const formattedDate = new Intl.DateTimeFormat('en-US', {
                    //     month: 'short',
                    //     day: '2-digit',
                    //     year: 'numeric'
                    // }).format(date);

                    return (
                        <p className="custom-text-datatable">{value}</p>
                    );
                },
                customHeadLabelRender: (columnMeta) => {
                    return <h4 className="custom-label-datatable">{columnMeta.label}</h4>;
                }
            }
        },
        {
            name: ("Details"),
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value, tableMeta, updateValue) => (
                    // <a href={value} target="_blank" className="redirect-link" onClick={() => handleDownloadPdf(value)} rel="noreferrer">Invoice Details</a>
                    <div className="invoices_actions_btn_wrapper">
                        <a href={value} target="_blank" className="redirect-link invoices_view_btn" rel="noreferrer">
                            <img src="/admin-images/new-view.svg" width="16" alt="" /> View
                        </a>
                        {/* {
                            loading ? <CircularProgress size={16} sx={{ color: '#18AEE3', marginLeft: '10px' }} /> : <button onClick={() => handleDownloadPdf(value)} className="invoices_download_btn">
                                <img src="/admin-images/new-download-pdf.svg" width="16" alt="" /> Download
                            </button>
                        } */}
                        {/* {
                            loadingRow === tableMeta.rowIndex ? (
                                <CircularProgress size={16} sx={{ color: '#18AEE3', marginLeft: '10px' }} />
                            ) : (
                                <button onClick={() => handleDownloadPdf(value, tableMeta.rowIndex)} className="invoices_download_btn">
                                    <img src="/admin-images/new-download-pdf.svg" width="16" alt="" /> Download
                                </button>
                            )
                        } */}
                    </div>
                ),
                customHeadLabelRender: (columnMeta) => {
                    return <h4 className="custom-label-datatable">{columnMeta.name}</h4>
                }
            }
        },
    ];


    const data = invoices?.data?.data?.length > 0 ? invoices?.data?.data?.map(invoice => {
        return [
            invoice.invoice_no, 
            invoice.reference_no !== '' && invoice.reference_no !== null ? invoice.reference_no : invoice.invoice_no, 
            invoice.final_amount_due, 
            invoice.amount_paid, 
            invoice.paid_at !== '' ? 'Yes' : 'No', 
            invoice.created_at, 
            invoice.public_url
        ]
    }) : []

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    
    const handleChangeRowsPerPage = (event) => {
        const newRowsPerPage = parseInt(event.target.value, 10);
        setRowsPerPage(newRowsPerPage);
        setPage(0);
    };

    const paginatedData = data?.slice(
        page * rowsPerPage, 
        page * rowsPerPage + rowsPerPage
    );

    const options = {
        search: true,
        serverSide: true,
        searchAlwaysOpen: true,
        selectableRows: "none",
        selectableRowsHideCheckboxes: false,
        download: true,
        print: true,
        delete: false,
        viewColumns: true,
        filter: true,
        filterType: "checkbox",
        responsive: "standard",
        sortThirdClickReset: true,
        draggableColumns: {
            enabled: true
        },
        // customToolbar: () => (
        //     <>
        //       <FormControl>
        //         <Select
        //           value={sortingColumnName !== null ? sortingColumnName : ''}
        //           onChange={handleSortingChange}
        //           displayEmpty
        //         >
        //           <MenuItem value='' disabled>Sort By</MenuItem>
        //           {columns.map((column, index) => (
        //             <MenuItem key={column.name} value={column.name}>{column.name}</MenuItem>
        //           ))}
        //         </Select>
        //       </FormControl>
        //       <FormControl>
        //         <Select
        //           value={sortingDirection}
        //           onChange={handleSortingDirectionChange}
        //         >
        //           <MenuItem value='asc'>Ascending</MenuItem>
        //           <MenuItem value='desc'>Descending</MenuItem>
        //         </Select>
        //       </FormControl>
        //     </>
        //   ),
        textLabels: {
            body: {
                noMatch: t("Sorry, no matching records found"),
                toolTip: t("Sort"),
                columnHeaderTooltip: column => `${t("Sort for")} ${column.label}`
            },
            pagination: {
                next: t("Next Page"),
                previous: t("Previous Page"),
                rowsPerPage: t("Rows per page"),
                displayRows: t("of"),
            },
            toolbar: {
                search: t("Search"),
                downloadCsv: t("Download CSV"),
                print: t("Print"),
                viewColumns: t("View Columns"),
                filterTable: t("Filter Table"),
            },
            filter: {
                all: t("All"),
                title: t("Filtres"),
                reset: "Reset",
            },
            viewColumns: {
                title: t("Show Columns"),
                titleAria: t("Show/Hide Table Columns"),
            },
            selectedRows: {
                text: t("row(s) selected"),
                delete: t("Delete"),
                deleteAria: t("Delete Selected Rows"),
            },
        },
        customSearchRender: (searchText, handleSearch, hideSearch, options) => {
            return (
              <CustomSearchRender
                searchText={searchText}
                onSearch={handleSearch}
                clearSearch={hideSearch}
              />
            );
          },
          customFooter: () => {
              return(
                  <CustomPagination
                      last_page={invoices?.data?.meta?.last_page ?? 1}
                      count={data?.length}
                      page={page}
                      rowsPerPage={rowsPerPage}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      position= "bottom"
                      numberOfRecords={paginatedData?.length}
                  />
              )
          },
        //   customToolbar: () => {
        //       return (
        //         <CustomPagination
        //           count={data?.length}
        //           page={page}
        //           rowsPerPage={rowsPerPage}
        //           onPageChange={handleChangePage}
        //           onRowsPerPageChange={handleChangeRowsPerPage}
        //           position= "top"
        //         />
        //       );
        //     },
        customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
            <div></div>
        ),
        onTableChange: (action, tableState) => {
            if (action === 'sort') {
                const { sortOrder } = tableState;
                setSortingColumnName(sortOrder?.name);
                setSortingDirection(sortOrder?.direction);
            }
        },
        sortOrder: {
            name: sortingColumnName,
            direction: sortingDirection
        },
        onRowsDelete: (rowsDeleted) => {

        }
    };
    const actions = <CustomBlueButton onClick={() => setOpenA(true)}>{t("See Agreements")}</CustomBlueButton>
    return (
        <>
            <Agreements open={openA} setOpen={setOpenA} />
            <UnSubscribe open={open} setOpen={setOpen} />
            <Header title="Invoices" actions={actions}/>
            <NextBilling subscriptions={invoices?.subscription_details} />
            <div className="new-datatable nowrap-table position-relative invoices_table mt-20">
                <ThemeProvider theme={getMuiTheme()}>
                    <MUIDataTable
                        data={data}
                        columns={columns}
                        options={options}
                    />
                </ThemeProvider>
                <button className="unsubscribe-btn" onClick={() => setOpen(true)} style={{position: 'relative', marginTop: '20px'}}>{t("Unsubscribe")}</button>
            </div>
        </>
    )
}
export default Invoices